import { jsx as i } from "react/jsx-runtime";
import l from "react";
import { clsx as s } from "../../../utils/clsx.js";
import '../../../assets/FlexRestricter.css';const n = "_root_1jvko_1", _ = "_vertical_1jvko_4", v = "_horizontal_1jvko_7", o = {
  root: n,
  vertical: _,
  horizontal: v
}, d = l.forwardRef(function(r, e) {
  const {
    vertical: t = !1,
    children: c
  } = r, a = s(o.root, {
    [o.vertical]: t,
    [o.horizontal]: !t
  });
  return /* @__PURE__ */ i("div", { ref: e, className: a, children: c });
});
export {
  d as FlexRestricter
};
